import SchoolForm from './SchoolForm';

export default SchoolForm;
